import DesktopSwitch from '../../components/DesktopSwitch';
import ChatsListMobile from './ChatsListMobile';
import ChatsListDesktop from './ChatsListDesktop';

/**
 * ChatsPage - Wrapper component that renders desktop or mobile view based on screen size
 * Desktop: ChatsListDesktop (sidebar + ProfileFull)
 * Mobile: ChatsListMobile (full list)
 */
function ChatsPage() {
  return (
    <DesktopSwitch desktop={ChatsListDesktop} mobile={ChatsListMobile} />
  );
}

export default ChatsPage;
